/// <amd-module name="TFS/CreateProject/Components/StatusMessageOverlay" />
import { Overlay } from "OfficeFabric/Overlay";
import * as React from "react";
import { StatusMessageType } from "TFS/CreateProject/Contracts";
import { IStatusMessage } from "TFS/CreateProject/Models";
import * as CreateProjectResources from "TFS/CreateProject/Resources";
import * as Utils_String from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

export interface IStatusMessageOverlayProps {
    statusMessage: IStatusMessage;
    onCtaClick: () => void;
}

export class StatusMessageOverlay extends VssComponent<IStatusMessageOverlayProps, {}> {
    public render(): JSX.Element | null {
        const { statusMessage, onCtaClick } = this.props;
        const statusMessageType = statusMessage.statusMessageType;
        const projectCreationInProgress = statusMessageType === StatusMessageType.Waiting;
        const showMessage = statusMessageType !== StatusMessageType.NoStatus;
        const showCta = statusMessage.showGoBackCta || statusMessage.showTryAgainCta;
        const ctaText = statusMessage.showGoBackCta ? CreateProjectResources.GoBackButtonText : CreateProjectResources.TryAgainButtonText;

        return showMessage ? (
            <Overlay className={"status-message-overlay flex flex-center justify-center"}>
                <div>
                    <div className={"status-message-overlay-container flex flex-column"}>
                        {projectCreationInProgress ? (
                            <>
                                <Spinner size={SpinnerSize.large} className={"status-message-spinner"} />
                                <span className={"status-message fontSizeML fontWeightSemiBold"}>{statusMessage.message}</span>
                            </>
                        ) : (
                            <>
                                <Icon className={"status-message-icon fontSizeXL"} iconName={"Warning"} />
                                <span className={"status-message status-message-text fontSizeML fontWeightSemiBold"}>
                                    {CreateProjectResources.GenericErrorMessage}
                                </span>
                                <span className={"status-sub-message fontSizeML"}>{statusMessage.message}</span>
                            </>
                        )}
                        {showCta && (
                            <div>
                                <Button primary={true} autoFocus={true} className={"status-message-cta"} text={ctaText} onClick={onCtaClick} />
                            </div>
                        )}
                    </div>
                </div>
            </Overlay>
        ) : null;
    }
}
